import { convertToApiQuery } from '@seek/seek-jobs-search-query';

import createRequest from '../create-request';
import pick from 'lodash.pick';

import { searchUrl, countsUrl } from 'config';
import { log } from 'logger';

const request = createRequest({ label: 'search' });

let onlySearchPromise, onlyCountsPromise;

const clean = object => pick(object, x => x);

function buildApiQuery(searchQuery, locale = 'AU', cookies, userQueryId) {
  const analyticsParams = !cookies ? {} : clean({
    userqueryid: userQueryId || null,
    userid: cookies.JobseekerVisitorId || null,
    usersessionid: cookies.JobseekerVisitorId || null,
    eventCaptureSessionId: cookies.JobseekerSessionId || null
  });

  const searchParams = convertToApiQuery({ locale, searchQuery });

  return {
    siteKey: `${locale.toUpperCase()}-Main`,
    ...analyticsParams,
    ...searchParams
  };
}

function search(searchParams, locale, cookies, userQueryId) {
  log.info({ params: searchParams }, `Calling Search API: ${searchUrl}`);

  if (onlySearchPromise) {
    onlySearchPromise.cancel();
  }

  const searchPromise = request
    .get(searchUrl)
    .query(buildApiQuery(searchParams, locale, cookies, userQueryId))
    .then(response => response.body);

  if (ENV.CLIENT) {
    onlySearchPromise = searchPromise;
  }

  return searchPromise;
}

function counts(searchParams, locale) {
  log.info({ params: searchParams }, `Calling Counts API: ${countsUrl}`);
  if (onlyCountsPromise) {
    onlyCountsPromise.cancel();
  }
  const countsPromise = request
    .get(countsUrl)
    .query(buildApiQuery(searchParams, locale))
    .then(response => response.body);

  if (ENV.CLIENT) {
    onlyCountsPromise = countsPromise;
  }

  return countsPromise;
}

export default {
  search,
  counts
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/seek-jobs-api-client/apis/jobs.js
 **/